<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-title color="white">Dettaglio evento</ion-title>
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="start" :icon="arrowBackOutline" color="white"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div class="page_content">

                <!-- Modale immagine ingrandita -->
                <Transition name="fade-transition">
                    <div v-show="showImgModal" class="attachment_modal">
                        <div class="customers_container">
                            <img :src="selectedImage" alt="Immagine evento" />
                        </div>
                        <div @click="closeAttachmentModal()" class="close_modal">Chiudi</div>
                    </div>
                </Transition>

                <div class="event">
                    <div v-if="event.events_title" class="event_title">
                        <div class="event_name">{{ event.events_title }}</div>
                    </div>

                    <div class="title">
                        <div class="event_date">{{ formatEventDate(event.events_date_start, event.events_date_end) }}</div>
                        <div class="event_time">
                            <div>{{ timeFormat(event.events_date_start) }} - {{ timeFormat(event.events_date_end) }}</div>
                        </div>
                    </div>

                    <div v-if="event.events_google_calendar" class="field_note">
                        <div class="title">Google calendar</div>
                        <div class="value">
                            {{ event.google_calendars_list_google_id }}
                        </div>
                    </div>

                    <div v-if="event.events_description" class="field_note">
                        <div class="title"></div>
                        <div class="value">
                            {{ event.events_description }}
                        </div>
                    </div>

                    <div v-if="event.events_image" class="field_note">
                        <div class="title"></div>
                        <div class="value">
                            <img :src="setImageUrl(event.events_image)" alt="" style="border-radius: 8px;">
                        </div>
                    </div>

                    <!-- Galleria immagini -->
                    <div v-if="event.events_gallery && event.events_gallery.length > 0" class="gallery-container">
                        <div class="gallery-scroll">
                            <div v-for="(img, idx) in JSON.parse(event.events_gallery)" :key="idx" class="gallery-thumb">
                                <img :src="galleryImageUrl(img)" :alt="img.original_filename || 'gallery'" @click="openImgDetail(img)" style="cursor:pointer;" />
                            </div>
                        </div>
                    </div>

                    <div class="field_note">
                        <div class="button_container_calendar">
                            <add-to-calendar-button
                                :name="event.events_title"
                                :description="event.events_description"
                                :location="event.events_address"
                                :startDate="formatDate(event.events_date_start)"
                                :endDate="formatDate(event.events_date_end)"
                                :startTime="formatTime(event.events_date_start)"
                                :endTime="formatTime(event.events_date_end)"
                                timeZone="Europe/Rome"
                                options="'Apple','Google'"
                                hideBranding
                                buttonsList
                                lightMode="bodyScheme"
                                styleLight="--btn-background: rgb(219 234 254); --btn-text: rgb(37 99 235); --btn-border: rgb(37 99 235); --btn-padding-x: 16px; --btn-padding-y: 8px;"
                            >
                            </add-to-calendar-button>
                        </div>
                    </div>

                    <!-- Dati cliente collegato -->
                    <div v-if="event.events_customer_id" class="customer_data">
                        <div class="title">
                            {{ event.customers_full_name }}
                        </div>
                        <div class="field">
                            <div class="title">Telefono</div>
                            <div v-if="event.customers_mobile" class="value">
                                <a :href="`tel:${event.customers_mobile}`" target="_blank" class="mobile_link">{{ event.customers_mobile }}</a>
                            </div>
                            <div v-else>-</div>
                        </div>
                        <div class="field">
                            <div class="title">Email</div>
                            <div v-if="event.customers_email" class="value">
                                <a :href="`mailto:${event.customers_email}`" target="_blank" class="mobile_link">{{ event.customers_email }}</a>
                            </div>
                            <div v-else>-</div>
                        </div>
                        <div class="field_note field_note_address">
                            <div class="title">Indirizzo</div>
                            <div class="value">
                                <a
                                    :href="`https://maps.google.com/?q=${event.customers_city} ${event.customers_address} ${event.customers_zip_code}`"
                                    target="_blank"
                                    class="mobile_link mobile_link_maps"
                                >
                                    {{ formattedAddress() }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="!event.events_customer_id && event.events_address" style="width:100%;">
                        <div class="field_note field_note_address">
                            <div class="title">Indirizzo</div>
                            <div class="value">
                                <a
                                    :href="`https://maps.google.com/?q=${event.events_address}`"
                                    target="_blank"
                                    class="mobile_link mobile_link_maps"
                                >
                                    {{ event.events_address }}
                                </a>
                            </div>
                        </div>
                    </div>


                    <div v-if="event.events_requires_confirmation && event.events_requires_confirmation == '1' && !confirmationSend" style="margin-top: 32px; width: 100%;">
                        <div style="text-align: center;">Parteciperai? Sì, ancora non lo so oppure no</div>

                        <div class="delete_button_container" style="display: flex; gap: 16px;">
                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(1)"         
                                    :class="{ active: selectedConfirmation === 1 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 1 ? 0.4 : 1 }"
                                    class="btn_partecipate confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-up']" style="color: rgb(37 99 235); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(37 99 235); font-size: 20px;">{{ event.count_yes }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(2)"         
                                    :class="{ active: selectedConfirmation === 2 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 2 ? 0.4 : 1 }"
                                    class="btn_partecipate maybe" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'question']" style="color: rgb(234 88 12); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(234 88 12); font-size: 20px;">{{ event.count_maybe }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(3)"         
                                    :class="{ active: selectedConfirmation === 3 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 3 ? 0.4 : 1 }"
                                    class="btn_partecipate not_confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-down']" style="color: rgb(220 38 38); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(220 38 38); font-size: 20px;">{{ event.count_no }}</div>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="event.events_requires_confirmation && event.events_requires_confirmation == '1' && confirmationSend" style="margin-top: 32px; width: 100%;">
                        <div style="text-align: center;">Modifica la tua risposta</div>

                        <div class="delete_button_container" style="display: flex; gap: 16px;">
                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(1)"         
                                    :class="{ active: selectedConfirmation === 1 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 1 ? 0.4 : 1 }"
                                    class="btn_partecipate confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-up']" style="color: rgb(37 99 235); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(37 99 235); font-size: 20px;">{{ event.count_yes }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(2)"         
                                    :class="{ active: selectedConfirmation === 2 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 2 ? 0.4 : 1 }"
                                    class="btn_partecipate maybe" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'question']" style="color: rgb(234 88 12); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(234 88 12); font-size: 20px;">{{ event.count_maybe }}</div>
                                </button>
                            </div>

                            <div class="button_container">
                                <button 
                                    @click="setConfirmation(3)"         
                                    :class="{ active: selectedConfirmation === 3 }"
                                    :style="{ opacity: selectedConfirmation && selectedConfirmation !== 3 ? 0.4 : 1 }"
                                    class="btn_partecipate not_confirm" 
                                    style="height: 40px;"
                                    >
                                    <font-awesome-icon :icon="['fas', 'thumbs-down']" style="color: rgb(220 38 38); font-size: 20px;" />
                                    <div class="answer_container" style="color: rgb(220 38 38); font-size: 20px;">{{ event.count_no }}</div>

                                </button>
                            </div>
                            
                        </div>
                    </div>

                    <div v-if="showAdditionalControls" class="additional_participants">
                        <div class="additional_label">Numero di partecipanti aggiuntivi</div>
                        <div class="additional_controls">
                            <button 
                                class="additional_button"
                                @click="decrementAdditional"
                                :disabled="additionalParticipants <= 0 || additionalLoading"
                            >
                                -
                            </button>
                            <div class="additional_value">{{ additionalParticipants }}</div>
                            <button 
                                class="additional_button"
                                @click="incrementAdditional"
                                :disabled="additionalLoading"
                            >
                                +
                            </button>
                        </div>
                        <button 
                            class="btn_save_additional"
                            @click="saveAdditionalParticipants"
                            :disabled="additionalLoading"
                        >
                            <span v-if="!additionalLoading">Salva</span>
                            <span v-else>Salvataggio...</span>
                        </button>
                    </div>

                    <!-- <div class="delete_button_container">
                        <button @click="deleteEvent()" class="btn_delete_event">Elimina evento</button>
                    </div> -->
                </div>

                <!-- Elenco partecipanti -->
                <div v-if="event.partecipants && event.partecipants.length > 0" class="event event_list">
                    <div class="event_title">
                        <div class="event_name">Elenco partecipanti</div>
                    </div>

                    <div v-for="(partecipant, index) in event.partecipants" :key="index" class="single_participant">
                        <span>{{ partecipant.users_first_name }} {{ partecipant.users_last_name }}</span>
                        <span
                            :style="{ color: getPartecipationColor(partecipant.events_participants_users_partecipate) }"
                            style="font-weight: 600;"
                        >
                            {{ partecipant.events_participants_users_partecipate_value }}
                            <span v-if="partecipant.events_participants_users_additional && parseInt(partecipant.events_participants_users_additional, 10) > 0">
                                +{{ partecipant.events_participants_users_additional }}
                            </span>
                        </span>
                    </div>
                </div>


            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    //IonBackButton,
    IonTitle,
    IonContent,
    IonIcon,
    IonButton,
    modalController,
    getPlatforms
} from "@ionic/vue";

import { defineComponent, ref, onMounted, computed } from "vue";
import { alertController } from "@ionic/vue";

import { arrowBackOutline } from "ionicons/icons";

import moment from "moment";
import 'add-to-calendar-button';

import { LOCALSTORAGE_KEY } from "@/custom_config";


import { openToast } from "@/services/toast";
import { dateFormat, timeFormat } from "@/services/utils";

import apiCalendario from "@/services/calendario";

export default defineComponent({
    name: "EvetDetail",
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    components: {
        IonPage,
        IonHeader,
        IonToolbar,
        IonButtons,
        //IonBackButton,
        IonTitle,
        IonContent,
        IonIcon,
        IonButton,
    },
    setup(props, context) {
        // console.log(props.data);
        const userID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_user_id;
        const userData = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`));

        const event = ref([]);
        event.value = { ...props.data };
        if (!Array.isArray(event.value.partecipants)) {
            event.value.partecipants = [];
        }
        //console.log(event.value);


        const isAndroid = ref(false);
        const isIos = ref(false);
        const platforms = getPlatforms();
        if (platforms.includes("android")) {
            isAndroid.value = true;
        } else if (platforms.includes("ios") || platforms.includes("iphone")) {
            isIos.value = true;
        }


        function setImageUrl(path) {
            if (path && path != '') {
                return `${process.env.VUE_APP_BASE_URL}/uploads/${path}`;
            }
        }

        // Helper per immagini della galleria
        function galleryImageUrl(img) {
            // console.log(img);
            if (img && img.path_local) {
                return `${process.env.VUE_APP_BASE_URL}/uploads/${img.path_local}`;
            }
            return '';
        }

        /**
         * Handle close modal by clicking on Chiudi button
         */
        const closeModal = (deleted = false) => {
            modalController.dismiss(deleted);
        };

        const formatEventDate = (startDate, endDate) => {
            const start = new Date(startDate);
            const end = new Date(endDate);

            if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth() && start.getDate() === end.getDate()) {
                return dateFormat(startDate);
            } else {
                return `${dateFormat(startDate)} - ${dateFormat(endDate)}`;
            }
        };

        const formattedAddress = () => {
            const { customers_address, customers_city, customers_province } = event.value;

            let formatted = "";

            if (customers_address && customers_address.trim() !== "") {
                formatted += customers_address + ", ";
            }
            if (customers_city && customers_city.trim() !== "") {
                formatted += customers_city + " (";
            }
            if (customers_province && customers_province.trim() !== "") {
                formatted += customers_province + ")";
            }

            return formatted;
        };

        async function handleCancellation() {
            if (event.value.events_id) {
                let deleted = false;

                const res = await apiCalendario.deleteEvent(event.value.events_id);

                if (res.status === 200 && res.data.status === 0) {
                    deleted = true;
                    closeModal(deleted);
                } else {
                    openToast("Si è verificato un durante l'eliminazione dell'evento", "toast_danger");
                    closeModal(deleted);
                }
            } else {
                openToast("Non è stato possibile riconscere l'evento da eliminare", "toast_danger");
            }
        }

        async function showAlert() {
            const alert = await alertController.create({
                header: "Elimina evento",
                message: "Vuoi eliminare definitivamente questo evento?",
                backdropDismiss: false,
                buttons: [
                    {
                        text: "Annulla",
                        handler: () => {
                            // Close alert
                        },
                    },
                    {
                        text: "Elimina",
                        handler: () => {
                            handleCancellation();
                        },
                    },
                ],
            });
            return alert.present();
        }

        async function deleteEvent() {
            await showAlert();
        }


        const confirmationSend = ref(false);
        const selectedConfirmation = ref(null);
        const currentRelationId = ref(null);
        const additionalParticipants = ref(0);
        const additionalLoading = ref(false);
        const showAdditionalControls = computed(() => selectedConfirmation.value === 1 && !!currentRelationId.value);

        function incrementAdditional() {
            additionalParticipants.value += 1;
        }

        function decrementAdditional() {
            if (additionalParticipants.value > 0) {
                additionalParticipants.value -= 1;
            }
        }

        function normalizeRelationId(value) {
            if (!value) {
                return null;
            }

            if (typeof value === "object") {
                if (value.id) {
                    return value.id.toString();
                }
                if (value.relation_id) {
                    return value.relation_id.toString();
                }
                if (value.events_participants_users_id) {
                    return value.events_participants_users_id.toString();
                }
            }

            return value.toString();
        }

        function normalizeAdditionalCount(value, fallback = 0) {
            const parsed = parseInt(value, 10);
            return Number.isNaN(parsed) || parsed < 0 ? fallback : parsed;
        }

        function getAdditionalCount(participant) {
            if (!participant) {
                return 0;
            }
            return normalizeAdditionalCount(participant.events_participants_users_additional, 0);
        }

        function getAttendeesTotalFromCount(additional) {
            return 1 + normalizeAdditionalCount(additional, 0);
        }

        function getParticipantTotalAttendees(participant) {
            return getAttendeesTotalFromCount(getAdditionalCount(participant));
        }

        function updateCountersDelta(statusValue, delta) {
            if (!statusValue || delta === 0) {
                return;
            }

            const status = parseInt(statusValue, 10);
            if (status === 1) {
                event.value.count_yes = Math.max(0, event.value.count_yes + delta);
            } else if (status === 2) {
                event.value.count_maybe = Math.max(0, event.value.count_maybe + delta);
            } else if (status === 3) {
                event.value.count_no = Math.max(0, event.value.count_no + delta);
            }
        }

        function resolveAdditionalCount(responseAdditional, fallbackParticipant, fallbackValue = 0) {
            if (responseAdditional !== null && typeof responseAdditional !== "undefined") {
                return normalizeAdditionalCount(responseAdditional, fallbackValue);
            }

            if (fallbackParticipant) {
                return getAdditionalCount(fallbackParticipant);
            }

            return normalizeAdditionalCount(fallbackValue, 0);
        }

        async function saveAdditionalParticipants() {
            if (!currentRelationId.value) {
                openToast("Non è stato possibile identificare la partecipazione", "toast_danger");
                return;
            }

            additionalLoading.value = true;
            
            // Converti relation_id in stringa (dovrebbe già essere una stringa)
            const relationIdString = normalizeRelationId(currentRelationId.value);
            if (!relationIdString) {
                openToast("Non è stato possibile identificare la partecipazione", "toast_danger");
                additionalLoading.value = false;
                return;
            }

            try {
                const res = await apiCalendario.addParticipants(relationIdString, additionalParticipants.value);

                if (res.status === 200 && res.data.status === 0) {
                    openToast(res.data.txt, "toast_success");

                    const participant = Array.isArray(event.value.partecipants)
                        ? event.value.partecipants.find(p => p.users_id === userID)
                        : null;

                    if (participant) {
                        const oldWeight = getParticipantTotalAttendees(participant);
                        const newAdditional = resolveAdditionalCount(
                            res.data ? res.data.additional : null,
                            null,
                            additionalParticipants.value
                        );
                        const newWeight = getAttendeesTotalFromCount(newAdditional);

                        participant.events_participants_users_additional = newAdditional.toString();
                        updateCountersDelta(
                            participant.events_participants_users_partecipate_id || participant.events_participants_users_partecipate,
                            newWeight - oldWeight
                        );

                        additionalParticipants.value = Math.max(0, newAdditional);
                    }
                } else {
                    openToast(res.data.txt, "toast_danger");
                }
            } catch (error) {
                openToast("Si è verificato un errore durante il salvataggio dei partecipanti aggiuntivi", "toast_danger");
            } finally {
                additionalLoading.value = false;
            }
        }

        async function setConfirmation(status) {
            try {
                const res = await apiCalendario.setConfirmation(event.value.events_id, userID, status);

                if (res.status === 200 && res.data.status === 0) {
                    openToast(res.data.txt, "toast_success");
                    confirmationSend.value = true;

                    if (!Array.isArray(event.value.partecipants)) {
                        event.value.partecipants = [];
                    }

                    const participantsList = event.value.partecipants;
                    const existingParticipant = participantsList.find(p => p.users_id === userID);
                    
                    // Estrai relation_id dalla risposta del backend
                    const relationId = res.data && res.data.relation_id ? normalizeRelationId(res.data.relation_id) : null;
                    const responseAdditional = resolveAdditionalCount(
                        res.data ? res.data.additional : null,
                        existingParticipant
                    );

                    let targetParticipant = existingParticipant;
                    let previousStatus = null;
                    let previousWeight = 0;

                    if (existingParticipant) {
                        previousStatus = existingParticipant.events_participants_users_partecipate_id || existingParticipant.events_participants_users_partecipate;
                        previousWeight = getParticipantTotalAttendees(existingParticipant);
                    }

                    if (!targetParticipant) {
                        targetParticipant = {
                            events_id: event.value.events_id,
                            users_id: userID,
                            users_first_name: userData.dipendenti_nome,
                            users_last_name: userData.dipendenti_cognome,
                            users_email: userData.dipendenti_email,
                            events_participants_users_additional: responseAdditional.toString()
                        };
                        participantsList.unshift(targetParticipant);
                        event.value.partecipants_count = participantsList.length;
                    }

                    targetParticipant.events_participants_users_partecipate = status.toString();
                    targetParticipant.events_participants_users_partecipate_id = status.toString();
                    targetParticipant.events_participants_users_partecipate_value =
                        status === 1 ? "Si" : status === 2 ? "Forse" : "No";
                    targetParticipant.events_participants_users_additional = responseAdditional.toString();

                    if (relationId) {
                        targetParticipant.events_participants_users_id = relationId;
                    }

                    updateCountersDelta(previousStatus, -previousWeight);
                    updateCountersDelta(status, getAttendeesTotalFromCount(responseAdditional));

                    selectedConfirmation.value = status;
                    
                    // Salva relation_id per permettere modifiche successive (es. partecipanti aggiuntivi)
                    // Il relation_id viene dalla risposta del backend e viene già assegnato al participant sopra
                    let nextRelationId = relationId;
                    if (!nextRelationId) {
                        if (existingParticipant && existingParticipant.events_participants_users_id) {
                            nextRelationId = normalizeRelationId(existingParticipant.events_participants_users_id);
                        } else {
                            const participant = participantsList.find(p => p.users_id === userID);
                            if (participant && participant.events_participants_users_id) {
                                nextRelationId = normalizeRelationId(participant.events_participants_users_id);
                            }
                        }
                    }

                    currentRelationId.value = nextRelationId;

                    const normalizedAdditional = Math.max(0, responseAdditional);

                    if (status === 1) {
                        additionalParticipants.value = Math.max(0, normalizedAdditional);
                    } else {
                        additionalParticipants.value = 0;
                    }
                } else {
                    openToast(res.data.txt, "toast_danger");
                }
            } catch (error) {
                openToast("Si è verificato un errore durante il salvataggio della risposta", "toast_danger");
            }
        }


        function checkConfirmation() {
            const participantsList = Array.isArray(event.value.partecipants) ? event.value.partecipants : [];
            const existingParticipant = participantsList.find(p => p.users_id === userID);

            if (existingParticipant) {
                confirmationSend.value = true;
                const participantStatus = parseInt(existingParticipant.events_participants_users_partecipate, 10);
                selectedConfirmation.value = isNaN(participantStatus) ? null : participantStatus;

                // Salva relation_id per permettere modifiche successive (es. partecipanti aggiuntivi)
                currentRelationId.value = existingParticipant.events_participants_users_id 
                    ? normalizeRelationId(existingParticipant.events_participants_users_id) 
                    : null;

                const participantAdditional = getAdditionalCount(existingParticipant);
                additionalParticipants.value = Math.max(0, participantAdditional);
            } else {
                confirmationSend.value = false;
                selectedConfirmation.value = null;
                currentRelationId.value = null;
                additionalParticipants.value = 0;
            }
        }


        function getPartecipationColor(value) {
            const colors = {
                1: "rgb(37 99 235)",  // Sì
                2: "rgb(234 88 12)",  // Forse
                3: "rgb(220 38 38)"   // No
            };
            return colors[value] || "inherit"; // Default se non corrisponde
        }


        // Calendar helpers
        const formatDate = (datetime) => {
            return moment(datetime).format("YYYY-MM-DD");
        };

        const formatTime = (datetime) => {
            return moment(datetime).format("HH:mm");
        };

        const showImgModal = ref(false);
        const selectedImage = ref(null);

        function openImgDetail(img) {
            showImgModal.value = true;
            selectedImage.value = galleryImageUrl(img);
        }

        function closeAttachmentModal() {
            showImgModal.value = false;
        }

        onMounted(() => {
            checkConfirmation();
        })

        return {
            event,
            setImageUrl,
            galleryImageUrl,
            dateFormat,
            timeFormat,
            arrowBackOutline,
            closeModal,
            deleteEvent,
            formatEventDate,
            formattedAddress,
            // Partecipazione ed elenco partecipanti
            setConfirmation,
            confirmationSend,
            selectedConfirmation,
            getPartecipationColor,
            currentRelationId,
            additionalParticipants,
            additionalLoading,
            incrementAdditional,
            decrementAdditional,
            saveAdditionalParticipants,
            showAdditionalControls,
            // Calendar helpers
            formatDate,
            formatTime,
            // Modal immagine
            showImgModal,
            selectedImage,
            openImgDetail,
            closeAttachmentModal,
        };
    },
});
</script>

<style scoped>
ion-toolbar {
    --background: #086fa3;
    --color: #ffffff;
}
.loading_spinner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

ion-item {
    font-size: 14px;
}
ion-label {
    margin: 0;
}

.description_title {
    color: var(--ion-color-primary, #3880ff) !important;
    margin: 10px 0;
}

/* New rules */
.page_content {
    width: 100%;
    position: relative; /* to be used for new event btn */
    padding: 16px;
    min-height: 100%;
    background: #f2f2f2;
}

.event {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}
.event_customer {
    margin-top: 24px;
}
.event > .event_title,
.event .customer_data > .title {
    width: 100%;
    padding: 8px;
    color: #121212;
    text-align: center;
}
.event > .title {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
}
.event .event_title .event_name {
    font-size: 20px;
    font-weight: 500;
}
.event .title .event_date {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}
.event .title .event_time {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}

.event .customer_data {
    width: 100%;
    margin-top: 24px;
    border-top: 0.5px solid #7676803d;
}
.event .field {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 12px 6px;*/
    padding: 12px 0px;
    /*margin-bottom: 10px;*/
    border-bottom: 1px solid #e2e8f0;
}
.event .customer_data .field {
    border-bottom: none;
}
.event .field_note {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px 0px;
    border-bottom: none;
}
.event .field_ricevuta {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px 6px;
}
.field .title,
.field_note .title,
.field_ricevuta .title {
    font-size: 14px;
    font-weight: 500;
    color: #121212;
}
.field_ricevuta .title {
    margin-bottom: 8px;
}
.field_note .title {
    margin-bottom: 8px;
}
.field .value,
.field_note .value,
.field_ricevuta .value {
    font-size: 14px;
}

.value .badge {
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
}

.value .badge.badge_inserita {
    background-color: rgb(254 243 199);
    color: rgb(245 158 11);
}
.value .badge.badge_rimborsata {
    background-color: rgb(220 252 231);
    color: rgb(34 197 94);
}
.value .badge.badge_rifiutata {
    background-color: rgb(254 226 226);
    color: rgb(239 68 68);
}
.value .badge.badge_accettata {
    background-color: rgb(219 234 254);
    color: rgb(59 130 246);
}
ion-button {
    --color: #ffffff;
}

.delete_button_container {
    width: 100%;
    margin-top: 24px;
}

.btn_delete_event {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    color: rgb(220 38 38);
    background-color: rgb(254 226 226);
}

.btn_partecipate {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    background-color: rgb(219 234 254);
    color: rgb(37 99 235);
}
.btn_partecipate.confirm {
    background-color: rgb(219 234 254);
    color: rgb(37 99 235);
    margin-bottom: 12px;
}
.btn_partecipate.maybe {
    color: rgb(234 88 12);
    background-color: rgb(255 237 213);
    margin-bottom: 12px;
}
.btn_partecipate.not_confirm {
    color: rgb(220 38 38);
    background-color: rgb(254 226 226);
}

.mobile_link {
    color: #086fa3;
    text-decoration: none;
}
.mobile_link_maps {
    width: 100%;
    display: block;
    text-align: right;
}

.event_list {
    margin-top: 24px;
}

.event_list .single_participant {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: 14px;
}

.button_container {
    width: 100%;
}

.button_container_calendar {
    width: 100%;
    display: flex;
    justify-content: center;
}

#atcb-reference {
    display: none;
}

add-to-calendar-button#css-part-example::part(atcb-button),
  #atcb-btn-css-part-example-modal-host::part(atcb-button) {
    background-color: #264f3c;
    color: #fff;
  }
  /* or, for all buttons and modals:
  .add-to-calendar::part(atcb-button) {
    background-color: #264f3c;
    color: #fff;
  }
  */

.gallery-container {
    width: 100%;
    margin: 12px 0 0 0;
    padding-bottom: 8px;
}
.gallery-scroll {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    gap: 12px;
    padding-bottom: 4px;
}
.gallery-thumb {
    flex: 0 0 auto;
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    background: #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.gallery-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
}

/* Modale immagine ingrandita */
.attachment_modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.customers_container {
    max-width: 90vw;
    max-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.attachment_modal img {
    max-width: 100%;
    max-height: 80vh;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.2);
}
.close_modal {
    margin-top: 24px;
    color: #fff;
    background: #086fa3;
    padding: 8px 24px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    transition: background 0.2s;
}
.close_modal:hover {
    background: #05507a;
}
/* Fade transition */
.fade-transition-enter-active, .fade-transition-leave-active {
    transition: opacity 0.2s;
}
.fade-transition-enter-from, .fade-transition-leave-to {
    opacity: 0;
}

.additional_participants {
    width: 100%;
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.additional_label {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    color: #121212;
}

.additional_controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.additional_button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background-color: rgb(219 234 254);
    color: rgb(37 99 235);
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.additional_button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.additional_value {
    min-width: 40px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #121212;
}

.btn_save_additional {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    background-color: rgb(37 99 235);
    color: #ffffff;
}

.btn_save_additional:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
</style>
